<template>
  <div class="exception notfound">
    <div>
      <div class="video-mask">
        <div><iframe src="https://giphy.com/embed/vFKqnCdLPNOKc" width="120%" height="110%" frameBorder="0" class="giphy-embed" allowFullScreen></iframe></div>
      </div>
      <h1>404<br>Pagina niet gevonden</h1>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CampaignNotFound',
};
</script>

<style lang="scss">
.exception {
  .video-mask {
    iframe {
      max-width: 150%;
      width: 150%;
    }
  }
}
</style>
